import { markNewProjectOnboardingIntent } from '../../features/onboarding';
import { APP_START_NEW_PROJECT } from '../site-control/events';

/** Сброс сессии + обучалка (лендинг, ЛК, первый вход). */
export const START_NEW_PROJECT_LOCATION_STATE = { startNewProject: true };

/** Сброс сессии без обучалки (кнопка «Новый проект» внутри /app). */
export const START_NEW_PROJECT_IN_APP_STATE = {
  startNewProject: true,
  skipOnboarding: true,
};

/**
 * Открыть редактор как новый пустой проект.
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {{ replace?: boolean, skipOnboarding?: boolean }} [options]
 */
export function navigateToNewProject(navigate, options = {}) {
  const skipOnboarding = Boolean(options.skipOnboarding);

  if (!skipOnboarding) {
    markNewProjectOnboardingIntent();
  }

  navigate('/app', {
    replace: Boolean(options.replace),
    state: skipOnboarding ? START_NEW_PROJECT_IN_APP_STATE : START_NEW_PROJECT_LOCATION_STATE,
  });

  queueMicrotask(() => {
    window.dispatchEvent(
      new CustomEvent(APP_START_NEW_PROJECT, {
        detail: { skipOnboarding },
      })
    );
  });
}
